import React from "react";
import { MessageBanner } from "@folio/stripes/components";
import { FormattedMessage } from "react-intl";
/**
 * Tells the title owner (and the agency) on the product detail that the co-publisher refused the
 * latest co-edition request, with its reason when given. A new request can still be filed.
 */
export var CoEditionDeclinedBanner = function (_a) {
    var _b, _c;
    var request = _a.request;
    return (React.createElement(MessageBanner, { type: "default" },
        React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.declined.banner", values: { coPublisher: (_c = (_b = request.coPublisher) === null || _b === void 0 ? void 0 : _b.name) !== null && _c !== void 0 ? _c : "" } }),
        request.coPublisherDecisionNote && (React.createElement("div", null,
            React.createElement(FormattedMessage, { id: "ui-br-agency.co-edition.consent.declined.reason", values: { reason: request.coPublisherDecisionNote } })))));
};
